import React from "react";
export default function LegalInfo() {
  return (
    <div className="section borderLight">
      <h2>Legal Information</h2>
      <p>Coming soon</p>
    </div>
  );
}
